"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertContextProvider = exports.useAlert = exports.useAlertContext = void 0;
const react_1 = __importDefault(require("react"));
const Snackbar_1 = __importDefault(require("@material-ui/core/Snackbar"));
const Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
function Alert(props) {
    return react_1.default.createElement(Alert_1.default, Object.assign({ elevation: 6, variant: "filled" }, props));
}
const AlertContext = react_1.default.createContext({
    //eslint-disable-next-line
    alert: () => { },
});
exports.useAlertContext = () => react_1.default.useContext(AlertContext);
exports.useAlert = () => react_1.default.useContext(AlertContext).alert;
exports.AlertContextProvider = react_1.default.memo(function AlertContextProvider({ children, }) {
    const [state, setState] = react_1.default.useState({ open: false, severity: 'success', message: 'default message' });
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setState({ open: false, message: '', severity: 'info' });
    };
    const alert = react_1.default.useCallback((message, severity) => {
        setState({ open: true, message, severity: severity });
    }, []);
    const value = react_1.default.useMemo(() => ({ alert }), [alert]);
    return (react_1.default.createElement(AlertContext.Provider, { value: value },
        react_1.default.createElement(Snackbar_1.default, { anchorOrigin: { vertical: 'top', horizontal: 'right' }, open: state.open, autoHideDuration: 6000, onClose: handleClose },
            react_1.default.createElement(Alert, { onClose: handleClose, severity: state.severity }, state.message)),
        children));
});
